/**
 * Created by Анжелика on 23.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as errors from '../constants/errors';
import StalkerApiManager from '../api/StalkerApiLoaderManager';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function initialLogin() {
    return dispatch => {
        if (loader.isLogin()) {
            dispatch({type: actionTypes.LOGIN_SUCCESS});
        }
    }
}

export function onError(error, defaultActionType) {
    switch (error) {
        case errors.TOKEN_WRONG:
        case errors.SERVER_NO_ANSWER:
            return({type: actionTypes.LOGIN_FAILED, hasError: true, error: error});

        default:
            return({type: defaultActionType, error: error});
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js